var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdPanel",
    [
      _c(
        "EmdPanelSection",
        { attrs: { title: _vm.$t("managing-partners") } },
        [
          _c(
            "jade-button",
            {
              attrs: {
                variant: "neutral-subtle",
                size: "medium",
                icon: "plus",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("add")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("add-managing-partner")) + " ")]
          ),
          _vm._l(_vm.managing_partners, function (partner, index) {
            return _c("EmdCollapse", {
              key: index,
              attrs: {
                title:
                  partner.name ||
                  _vm.$t("managing-partner", { number: index + 1 }),
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c("managing-partner-item", {
                          attrs: { recipient: partner },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("jade-icon-button", {
                          attrs: {
                            variant: "danger-ghost",
                            size: "small",
                            icon: "trash",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("remove", index)
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }